export default __webpack_public_path__ + "static/media/logo_freshdesk.8bd0b606.svg";